import React, { useEffect, useState } from 'react'
import { Organization } from '../../../../organization/types/organization.types';
import { useAuth } from '../../../../auth/hooks';
import { userRoles } from '../../../../user/types/user.types';
import FilterButtonDrawer, { FilterDrawerContainer, FilterStatusItem } from '../../../../../common/components/atom/FilterButtonDrawer/FilterButtonDrawer';
import OrganizationPicker from '../../../../organization/components/OrganizationPicker/OrganizationPicker';
import SingleOrganization from '../../../../organization/components/SingleOrganization';
import useCreateUserLink from '../../../hooks/useCreateUserLink';

export default function CreateUserLinkFilter() {


  const {
   allCreateUserLinksQuery: {  removeFromFilter , currentFilterObject, setFilterObject },
  } = useCreateUserLink();
  const [organizationFilter, setOrganizationFilter] = useState<
    Organization | undefined
  >();

  const { userRole } = useAuth();


  useEffect(() => {
    if (organizationFilter) {
      setFilterObject({
        uct_organization_id: {
          operator: "eq",
          values: [organizationFilter.organization_id],
          attribute: "uct_organization_id",
        },
      });
    }
  }, [organizationFilter]); // eslint-disable-line


  if (userRole && (userRole < userRoles.SUPER_ADMIN)) {
    return <></>
  }
  return (
    <div>
      <FilterButtonDrawer
        label="Filtre"
        childrenRender={({ closeDrawer }) => (
          <FilterDrawerContainer>
            <OrganizationPicker
              label="Organisation"
              setOrganization={setOrganizationFilter}
              currentOrganization={organizationFilter}
              style={{ height: 35, width: 250 }}
            />
          </FilterDrawerContainer>
        )}
        filterStatusRender={
          currentFilterObject?.uct_organization_id?.values[0]
            ? () => (
                <>
                  <FilterStatusItem
                    labelRender={() => (
                      <SingleOrganization.Info
                        id={
                          currentFilterObject?.uct_organization_id
                            ?.values[0] as string
                        }
                        info="organization_name"
                      />
                    )}
                    onClickDelete={() => {
                      removeFromFilter(["uct_organization_id"]);
                      setOrganizationFilter(undefined);
                    }}
                  />
                </>
              )
            : undefined
        }
      />
    </div>
  );
};




